<template>
  <div class="management-content">
    <div class="title-box">
      <div class="page-title">{{ $t("Header_Log") }}</div>
      <div class="right-box">
        <!-- 검색 -->
        <a-input-search class="search-input" v-model:value="searchText" :placeholder="$t('Common_Search')" @search="onSearch" />
        <div class="page-buttons">
          <!-- <a-button class="menu-button" @click="logDownload">다운로드</a-button> -->
        </div>
      </div>
    </div>
    <CommonTable :loading="loading" :data="tableData" :columns="columns" :pagination="pagination"
      :handleTableChange="handleTableChange" settingType="user" />
  </div>
</template>

<script>
import {
  computed,
  onMounted,
  onUpdated,
  reactive,
  ref,
  toRefs,
  watch,
} from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { apiUrl, timeFormatFromUTCEpoch, nowEpoch } from "@/utils/common";
import CommonTable from "@/components/commonComponents/CommonTable";
import { useI18n } from "vue-i18n";
// import fileDownload from "js-file-download";

export default {
  name: "Log",
  components: {
    CommonTable,
  },
  setup() {
    const store = useStore();
    const logState = computed(() => store.getters["log/STATE"]);
    const { t } = useI18n();

    const state = reactive({
      loading: false,
      logVisible: false,
      searchText: '',
      pagination: {},
      pagesize: 12,
      currentPage: 1,
      tableData: [],
    });

    const columns = [
      {
        title: "No",
        dataIndex: "logNo",
        align: "center",
        width: 50,
      },
      {
        title: t("TP_Edit_2_Reservation_list1"),
        dataIndex: "userName",
        align: "center",
        width: 100,
        ellipsis: true,
      },
      {
        title: "ID",
        dataIndex: "userId",
        align: "center",
        width: 100,
        ellipsis: true,
      },
      {
        title: t("Log1"),
        dataIndex: "logTitle",
        align: "center",
        width: 300,
        ellipsis: true,
      },
      {
        title: "API",
        dataIndex: "apiName",
        align: "center",
        width: 100,
      },
      {
        title: t("Log2"),
        dataIndex: "ip",
        align: "center",
        width: 100,
      },
      {
        title: t("Log3"),
        dataIndex: "regEpoch",
        align: "center",
        width: 100,
        slots: { customRender: "dateTime" },
      },
    ];

    onMounted(() => {
      getLog();
    });

    watch(
      () => state.currentPage,
      () => {
        getLog();
      }
    );

    // 페이지 변경 이벤트
    const handleTableChange = (pagination, filters, sorter) => {
      state["currentPage"] = pagination.current;
    };

    const filterState = reactive({
      visible: false,
    });
    const onSearch = (value) => {
      // 1페이지로 초기화
      state.currentPage = 1;
      getLog();
    };

    const getLog = async () => {
      state.loading = true;
      try {
        // filter 동적 생성
        const filter = {};
        if (state.searchText) filter.searchAll = state.searchText;
        const params = {
          filter,
          sort: {},
          offset: state.pagesize * (state.currentPage - 1),
          limit: state.pagesize,
        };

        const response = await axios.get(apiUrl + "Log", { params });
        if (response && !response.data.error) {
          store.dispatch("log/GET_LOG", response);
          state.tableData = response.data.list;
          state.pagination.current = state.currentPage;
          state.pagination.pageSize = state.pagesize;
          state.pagination.total = logState.value.totalCount;
        }
      } catch (error) {
        console.log("get log error", error);
      }
      state.loading = false;
    };
    
    return {
      ...toRefs(state),
      columns,
      handleTableChange,
      filterState,
      onSearch,
    };
  },
};
</script>

<style></style>